import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const FrameworksPage = lazy(() => import('../pages/frameworks/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ApplyPage = lazy(() => import('../pages/apply/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/frameworks',
    element: <FrameworksPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/apply',
    element: <ApplyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;